import React from "react";
import { Item } from "./Yuyue";
import styles from "../css/Yuyue.css";
import { Header } from "./Introduce";
import { Button, Toast } from "antd-mobile";
import { request } from "../request";
import { checkPhone, checkNum, checkZE, Loading } from "../tools/wechatBrower";
import _ from "lodash";

export function getId(name) {
  return document.getElementById(name)
    ? document.getElementById(name).value
    : "";
}

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        info: [],
        default: {},
      },
      loading: false,
      tag: '',
      name: '',
      phone: '',
      address: ""
    };
  }

  componentDidMount() {
    this.init();
  }

  init() {
    this.state = {
      data: {
        info: [],
        default: {},
      },
    };

    this.setState({
      model: this.props.match.params.model,
    });
  }

  getId(name) {
    return document.getElementById(name).value;
  }

  main() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div className={styles.info}>
          <div className={styles.head}>
            <span className={styles.title}>收件信息</span>
          </div>
          <Item left="* 标签" rightP="收件标签" id="tag"
            value={this.state.tag}
            onChange={(e) => {
              this.setState({ "tag": e });
            }}
            // onBlur={(e) => {
            //   let is_topic_leader = checkZE(this.state.tag);
            //   if (!is_topic_leader) {
            //     Toast.fail("标签只允许中英文,最多二十个字");
            //     return;
            //   }
            // }}
          ></Item>
          <Item
            left="* 姓名"
            rightP="请输入姓名"
            id="name"
            value={this.state.name}
            onChange={(e) => {
              this.setState({ "name": e });
            }}
            onBlur={(e) => {
              let is_topic_leader = checkZE(this.getId("name"));
              if (!is_topic_leader) {
                Toast.fail("姓名只允许中英文,最多二十个字");
                return;
              }
            }}
          ></Item>
          <Item
            left="* 联系电话"
            rightP="请输入联系电话"
            id="phone"
            value={this.state.phone}
            onChange={(e) => {
              if (checkNum(e)) {
                this.state.phone = e;
                this.setState();
              }
            }}
            onBlur={(e) => {
              let is_phone = checkPhone(this.state.phone);
              if (!is_phone) {
                Toast.fail("手机号格式不正确");
                return;
              }
            }}
          ></Item>
          <Item left="* 收件地址" rightP="请输入收件地址" id="address"
             value={this.state.address}
            onChange={(e) => {
              if (e.length < 100) {
                this.state.address = e;
                this.setState();
              }
            }}
            onBlur={(e) => {
              if (this.state.address > 100) {
                Toast.fail("地址电话最多100个字符");
                return;
              }

            }}></Item>
        </div>
      </div>
    );
  }

  _sub() {
    this.setState({
      loading: true,
    });

    if (
      !(getId("name") && this.state.phone && getId("address") && getId("tag"))
    ) {
      Toast.fail("必填项不得为空");
      this.setState({
        loading: false,
      });
      return;
    }

    var phone = this.state.phone;
    if (!/^1[3|4|5|7|8]\d{9}$/.test(phone)) {
      Toast.fail("手机号码有误，请重填");
      this.setState({
        loading: false,
      });
      return false;
    }
    let is_topic_leader = checkZE(getId("name"));
    if (!is_topic_leader) {
      Toast.fail("姓名只允许中英文,最多二十个字");
      this.setState({
        loading: false,
      });
      return;
    }

    request(
      "index/createReceiving",
      {
        tag: getId("tag"),
        uid: localStorage.getItem("openid"),
        name: getId("name"),
        phone: this.state.phone,
        address: getId("address"),
      },
      ({ data }) => {
        console.log(data);
        // eslint-disable-next-line
        if (data.code === 1) {
          Toast.success("添加成功");
          setTimeout(() => {
            this.props.history.push("/receivingInformation/list");
          }, 500);
        } else {
          Toast.fail("标签不得重复");
        }
        this.setState({
          loading: false,
        });
      }
    );
  }

  sumbit() {
    return (
      <div
        style={{
          position: "fixed",
          height: "70px",
          left: 0,
          bottom: 0,
          right: 0,
          // backgroundColor: "rgb(51 51 51 / 14%)",
          display: "flex",
          maxWidth: "375px",
          margin: "auto",
        }}
      >
        <Button
          type="primary"
          style={{
            width: "88%",
            backgroundColor: "#AE5CC9",
            borderRadius: "23px",
            border: "1px solid #AE5CC9",
            margin: "auto",
          }}
          onClick={_.throttle(this._sub.bind(this), 500)}
        >
          添加
        </Button>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Header text="收件信息"></Header>
        {this.main()}
        <div style={{ height: "80px", width: "100%" }}></div>

        {this.sumbit()}
        <Loading loading={this.state.loading}></Loading>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ReceivingAdd.js